import React, { useContext } from "react";
import { IconButton, useTheme } from "@mui/material";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import { ColorModeContext } from "./ThemeContext";

export default function ThemeToggle() {
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);
  const isDark = theme.palette.mode === "dark";

  return (
    <IconButton
      onClick={colorMode.toggleColorMode}
      size="small"
      sx={{
        color: "rgba(255,255,255,0.6)",
        border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: "8px",
        p: 0.75,
        transition: "color 0.2s, background 0.2s, border-color 0.2s",
        "&:hover": {
          color: "#c9a96e",
          bgcolor: "rgba(192,168,140,0.12)",
          borderColor: "rgba(192,168,140,0.3)",
        },
      }}
    >
      {isDark ? <Brightness7 sx={{ fontSize: 18 }} /> : <Brightness4 sx={{ fontSize: 18 }} />}
    </IconButton>
  );
}
